export class Test {

	chartData = [
	{ month: 'Jan', sales: 35 },
	{ month: 'Feb', sales: 28 },
	{ month: 'Mar', sales: 34 },
	{ month: 'Apr', sales: 32 },
	{ month: 'May', sales: 40 },
	{ month: 'Jun', sales: 32 },
	{ month: 'Jul', sales: 35 },
	{ month: 'Aug', sales: 55 },
	{ month: 'Sep', sales: 38 },
	{ month: 'Oct', sales: 30 },
	{ month: 'Nov', sales: 25 },
	{ month: 'Dec', sales: 32 }];

tooltip = {
	//Enable tooltip in chart area
	visible: true
};

title = {
	//Add chart title
	text: 'Sales Analysis'
};

	marker = {
	dataLabel: {
		//Enable data label in the chart 
		visible: false,
		//Set the id of HTML template to the chart series
		template: "dataLabelTemplate"
	}
};

//Customize the axis label format.
    primaryYAxis = { labelFormat: '${value}K' };
}